import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, first, from, tap } from "rxjs";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { eContracts } from "../contract.config";

@Injectable({
    providedIn: 'root'
})

export class TokenService {

    public contract;
    private _KMONbalance: ReplaySubject<{ float: number, wei: string }> = new ReplaySubject<{ float: number, wei: string }>(1);

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.KMONToken);
        // this.contractsService.getContractIstances(eContracts.KMONToken).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract( eContracts.KMONToken);

    }

    allowance(ownerAddress: string, spenderAddress: string): Observable<any> {
        return from(this.contract.methods.allowance(ownerAddress, spenderAddress).call());
    }

    approve(wallet, address: string, amount: number = 999999999999): Observable<any> {
        let web3 = this.web3Service.getWeb3();
        return from(this.contract.methods.approve(address, web3.utils.toWei(amount.toString())).send({ from: wallet }));
    }

    KMONbalance(ownerAddress: string): Observable<any> {
        return from(this.contract.methods.balanceOf(ownerAddress).call()).pipe(
            tap(/* async */ v => {
                this._KMONbalance.next({
                    float: this.web3Service.fromWeiFloat(v),
                    wei: v
                });
            }));
    }
    get KMONBalance$(): Observable<{ float: number, wei: string }> {
        return this._KMONbalance.asObservable();
    }
}